/** Retour en haut immédiat (sans animation): le CSS global active un défilement doux qui, sinon, s'interrompt en route. */
export const scrollTopNow = () => window.scrollTo({ top: 0, left: 0, behavior: 'instant' });

/**
 * Centre l'onglet sélectionné dans sa rangée défilante, en horizontal seulement.
 * (`scrollIntoView` ferait aussi défiler la page entière jusqu'à la rangée, y compris au chargement.)
 */
export function centerSelectedTab(bar: HTMLElement | null): void {
  const el = bar?.querySelector<HTMLElement>('[aria-selected="true"]');
  if (!bar || !el) return;
  const left = el.getBoundingClientRect().left - bar.getBoundingClientRect().left + bar.scrollLeft - (bar.clientWidth - el.offsetWidth) / 2;
  bar.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
}
